/**
 * Path Firestore della configurazione colori tipologia (PR-I, Q1).
 *
 * Collection root dedicata con documento SINGOLO a id fisso. Le rules
 * negano ogni write da client (`allow write: if false`): l'unica via di
 * scrittura e' la Cloud Function `updateTipologieColori` (Admin SDK).
 *
 * DUPLICAZIONI NOTE E BLINDATE DA TEST:
 *  1. `firestore.rules` ripete la stringa `config_tipologie` perche' le
 *     rules non possono importare costanti TS — duplicazione irriducibile.
 *  2. `functions/src/tipologie/constants.ts` ripete le stesse stringhe
 *     perche' le Cloud Functions non possono importare da `src/shared`
 *     (tsconfig rootDir=src). Un guard test di parita' lato functions
 *     confronta i due file e rompe in caso di drift.
 */

/** Collection root della configurazione colori tipologia. */
export const CONFIG_TIPOLOGIE_COLLECTION = 'config_tipologie';

/** Id fisso del documento di configurazione. */
export const CONFIG_TIPOLOGIE_DOC_ID = 'appuntamento';

/** Campo che contiene i mapping tipologia -> id token di palette. */
export const CONFIG_TIPOLOGIE_FIELD = 'colori';
